import * as Yup from "yup";

import { yupObjectValidation } from "../../validationServices";

export const useParticipantSignupValidationSchema = () => {
  const initialValues = {
    email: "",
    phone: "",
    password: "",
    changepassword: "",
    name: "",
    comp_name: "",
  };

  const validationSchema = {
    name: yupObjectValidation.name1,
    comp_name: yupObjectValidation.company_name2,
    email: yupObjectValidation.email1,
    phone: yupObjectValidation.phone1,
    password: yupObjectValidation.password,
    changepassword: yupObjectValidation.change_password,
  };

  const participantSignupValidationSchema = Yup.object().shape(
    validationSchema,
  );

  return {
    initialValues,
    participantSignupValidationSchema,
  };
};
